import Skeleton from '@mui/material/Skeleton';
import { Typography } from '@upheal/design-system/components/Typography/Typography';
import { lineHeightValues } from '@upheal/design-system/theme/design-system/tokens';
import pxToRem from '@upheal/design-system/theme/functions/pxToRem';
import { formatPriceWithCurrency } from '../utils/payments';

export type MainPriceProps = {
    price: number;
    currency?: string;
    isLoading?: boolean;
};

export const MainPrice = ({
    price,
    currency = 'USD',
    isLoading = false,
}: MainPriceProps) => {
    if (isLoading) {
        return <Skeleton height={lineHeightValues['h4']} width={50} />;
    }

    return (
        <Typography
            variant="h4"
            fontWeight="bold"
            sx={{
                fontSize: pxToRem(30),
                lineHeight: '100%',
            }}
        >
            {formatPriceWithCurrency(price, currency)}
        </Typography>
    );
};
